import { BrowserRouter } from 'react-router-dom';
import { StorefrontRouter } from './routes/StorefrontRouter';
import { StorefrontThemeProvider } from './features/storefront/theme/StorefrontThemeProvider';

export default function App() {
  return (
    <StorefrontThemeProvider>
      <BrowserRouter>
        <StorefrontRouter />
      </BrowserRouter>
    </StorefrontThemeProvider>
  );
}
